import apiDB from "./api_db";
import store from "../store";
import notification from "../components/subcomponents/notification";
import connect_api from "../connect/connect_api";

class apiDBModuleComponent extends apiDB {
  free_controllers_for_component_class() {
    const state = store.getState();
    console.log(state.moduleR.free_controllers.req_component_type);
    console.log(state.moduleR.free_controllers.req_class_prop);
    console.log(state.moduleR.module_component.details);
    connect_api.sPOST(
      "/" + this.api_module + "/free_controllers_for_component_class",
      {
        component_class: state.moduleR.module_component.details.component_class,
      },
      function (error, response) {
        if (error) {
          notification.error(error.message);
        } else {
          store.dispatch({
            type: "MODULE_COMPONENT_FREE_CONTROLLERS",
            data: response.api_data,
          });
        }
      }
    );
  }
  free_components_for_component_class() {
    const state = store.getState();
    connect_api.sPOST(
      "/" + this.api_module + "/free_components_for_component_class",
      {
        controller_id: state.moduleR.free_controllers.selected,
        component_class: state.moduleR.module_component.details.component_class,
      },
      function (error, response) {
        if (error) {
          notification.error(error.message);
        } else {
          store.dispatch({
            type: "MODULE_COMPONENT_FREE_COMPONENTS",
            data: response.api_data,
          });
        }
      }
    );
  }
  component_classes_for_component_type() {
    const state = store.getState();
    connect_api.sPOST(
      "/" + this.api_module + "/component_classes_for_component_type",
      { component_type: state.moduleR.free_controllers.req_component_type },
      function (error, response) {
        if (error) {
          notification.error(error.message);
        } else {
          store.dispatch({
            type: "MODULE_COMPONENT_COMPONENT_CLASSES",
            data: response.api_data,
          });
        }
      }
    );
  }

  update(callback) {
    let self = this;
    const state = store.getState();
    const action_types = {
      success: this.action_prefix + "_UPDATED",
      validation_error: this.action_prefix + "_VALIDATION_ERROR",
      operation_error: this.action_prefix + "_UPDATED_ERROR",
    };
    connect_api.sPOST(
      "/" + this.api_module + "/update",
      {
        component_id:
          state[this.reducer_name][this.reducer_var].details.component_id,
        component_class:
          state[this.reducer_name][this.reducer_var].details.component_class,
        component_config:
          state[this.reducer_name][this.reducer_var].details.component_config,
        disabled: state[this.reducer_name][this.reducer_var].details.disabled,
      },
      function (error, response) {
        self.parseResponse(error, response, action_types, callback);
      }
    );
  }
  update_free_component(callback) {
    let self = this;
    const state = store.getState();
    const action_types = {
      success: this.action_prefix + "_UPDATED",
      validation_error: this.action_prefix + "_VALIDATION_ERROR",
      operation_error: this.action_prefix + "_UPDATED_ERROR",
    };
    connect_api.sPOST(
      "/" + this.api_module + "/update_free_component",
      {
        component_id: state[this.reducer_name].free_components.selected,
        module_id: state[this.reducer_name].module.details.module_id,
        class_prop: state[this.reducer_name].free_controllers.req_class_prop,
        component_class:
          state[this.reducer_name][this.reducer_var].details.component_class,
      },
      function (error, response) {
        self.parseResponse(error, response, action_types, callback);
      }
    );
  }
  clear_component(callback) {
    let self = this;
    const state = store.getState();
    const action_types = {
      success: this.action_prefix + "_CLEARED",
      validation_error: this.action_prefix + "_VALIDATION_ERROR",
      operation_error: this.action_prefix + "_CLEARED_ERROR",
    };
    connect_api.sPOST(
      "/" + this.api_module + "/clear_component",
      {
        component_id:
          state[this.reducer_name][this.reducer_var].details.component_id,
      },
      function (error, response) {
        self.parseResponse(error, response, action_types, callback);
      }
    );
  }
}

let module_component = new apiDBModuleComponent({
  api_module: "module_component",
  table_key_name: "component_id",
  reducer_name: "moduleR",
  reducer_var: "module_component",
  action_prefix: "MODULE_COMPONENT",
  linked_table: "module",
  linked_table_key_name: "module_id",
});

export default module_component;
